import axios from 'axios';
import store from '../store/';

const config = require('../config/environment.json');

/** ========= Axios instances ========= **/
const api = axios.create({
  baseURL: config.api.baseURL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

const authApi = axios.create({
  baseURL: config.api.baseURL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

/** ========= State for refresh flow ========= **/
let isRefreshing = false;
let pendingQueue = [];

/** ========= Helpers ========= **/
const norm = (s = '') => String(s || '').toLowerCase();

const getAccessToken = () =>
  store.state.userPortalWeflix?.acessToken || store.state.token;

const getRefreshToken = () =>
  store.state.userPortalWeflix?.refreshToken || store.state.refreshToken;

const commitAccessToken = (newAccessToken) => {
  // Atualiza onde fizer sentido para seu app
  if (store.state.token || !store.state.userPortalWeflix) {
    store.commit('SET_TOKEN', newAccessToken);
  }
  if (store.state.userPortalWeflix) {
    store.commit('SET_USER_PORTAL_WEFLIX', {
      ...store.state.userPortalWeflix,
      acessToken: newAccessToken,
    });
  }
};

const enqueue = (cb) => pendingQueue.push(cb);
const flushQueue = (error, token) => {
  pendingQueue.forEach((cb) => cb(error, token));
  pendingQueue = [];
};

/** Garante Authorization em TODAS as variações de headers do Axios v1 */
function setAuthHeader(config, token) {
  // Cria o objeto caso não exista
  config.headers = config.headers || {};

  // Limpa variações antigas (evita ficar com 2 Authorization)
  delete config.headers.Authorization;
  delete config.headers.authorization;

  // Alguns casos criam headers específicos por método
  const method = (config.method || 'get').toLowerCase();
  if (config.headers.common) {
    delete config.headers.common.Authorization;
    delete config.headers.common.authorization;
  }
  if (config.headers[method]) {
    delete config.headers[method].Authorization;
    delete config.headers[method].authorization;
  }

  // Seta de forma simples (Axios normaliza depois)
  config.headers.Authorization = `Bearer ${token}`;

  return config;
}

function logoutUser() {
  console.log('[AUTH] Logout → /login');
  localStorage.removeItem('vuex');
  localStorage.removeItem('activeIndex');
  window.location.href = '/login';
}

function logoutUserSite() {
  console.log('[AUTH] Logout site → /');
  localStorage.removeItem('vuex');
  localStorage.removeItem('activeIndex');
  window.location.href = '/';
}

/** ========= Core: refresh + retry ========= **/
async function refreshTokenAndRetry(originalRequest) {
  console.log('[AUTH] refreshTokenAndRetry → start', {
    url: originalRequest?.url,
    _retry: originalRequest?._retry,
  });

  if (isRefreshing) {
    console.log('[AUTH] Já em refresh: enfileirando retry');
    return new Promise((resolve, reject) => {
      enqueue((err, newToken) => {
        if (err) return reject(err);
        const cfg = setAuthHeader({ ...originalRequest }, newToken);
        console.log('[AUTH] Retentando após refresh pendente:', cfg.url);
        resolve(api.request(cfg));
      });
    });
  }

  isRefreshing = true;
  try {
    const rToken = getRefreshToken();
    console.log('[AUTH] Solicitando refresh…');
    const { data: newAccessToken } = await authApi.post('/auth/refresh', null, {
      headers: { Authorization: `Bearer ${rToken}` },
    });

    console.log('[AUTH] Refresh OK.');
    commitAccessToken(newAccessToken);

    // Libera fila
    isRefreshing = false;
    flushQueue(null, newAccessToken);

    // Retry da requisição original com token novo
    const cfg = setAuthHeader({ ...originalRequest }, newAccessToken);
    console.log('[AUTH] Retentando requisição original:', cfg.url);
    return api.request(cfg);
  } catch (err) {
    console.log('[AUTH] Refresh falhou:', err);
    isRefreshing = false;
    flushQueue(err, null);
    logoutUser();
    throw err;
  }
}

/** ========= REQUEST interceptor ========= **/
// api.interceptors.request.use(
//   (cfg) => {
   
//     console.log('[HTTP][REQ]', {
//       method: (cfg.method || 'GET').toUpperCase(),
//       url: cfg.url,
//     });
//     return cfg;
//   },
//   (error) => {
//     console.log('[HTTP][REQ][ERRO]', error);
//     return Promise.reject(error);
//   }
// );

// /** ========= RESPONSE interceptor ========= **/
// api.interceptors.response.use(
//   (res) => {
//     console.log('[HTTP][RES]', { url: res.config?.url, status: res.status });
//     return res;
//   },
//   async (error) => {
//     const originalRequest = error.config || {};
//     const status = error.response?.status ?? null;
//     const reqUrl = norm(originalRequest.url);

//     console.log('[HTTP][RES][ERRO]', {
//       status,
//       url: reqUrl,
//       _retry: originalRequest._retry,
//     });

//     // Endpoints a ignorar para refresh
//     const ignoredApiEndpoints = ['/auth/refresh', '/auth/validate', '/public/', '/ecommerce/insert'];
//     const shouldIgnoreEndpoint = ignoredApiEndpoints.some((s) => reqUrl.includes(norm(s)));

//     try {
//       switch (status) {
//         case 401: {
//           // Evita loop e ignora apenas os endpoints blacklist
//           if (!shouldIgnoreEndpoint && !originalRequest._retry) {
//             originalRequest._retry = true;
//             return await refreshTokenAndRetry(originalRequest);
//           }
//           console.log('[AUTH] 401 ignorado ou já retentado.');
//           break;
//         }

//         case 400:
//           // regra opcional
//           logoutUser();
//           break;

//         case 403:
//           logoutUserSite();
//           break;

//         case 409:
//           // ignore
//           return;
//       }

//       return Promise.reject(error);
//     } catch (err) {
//       console.error('[AUTH] Erro no interceptor (fallback logout):', err);
//       logoutUser();
//       return Promise.reject(err);
//     }
//   }
// );

export default api;
